import React from "react";
import PageHeadingWithImage from "../../components/pageheading/PageHeadingWithImage";
import GetStartedBanner from "../../components/ctabanner/GetStartedBanner";
// import Button from "../../components/singlecomponents/Button";
import YellowDivider from "../../components/dividers/YellowDivider";
import LearningPathwayContainer from "../../components/sections/LearningPathwayContainer";
import FeaturedAcademyContent from "../../components/contentpreview/FeaturedAcademyContent";
import StartLearningNowBanner from "../../components/ctabanner/StartLearningNowBanner";
import { useTranslation } from "react-i18next";
import UpcomingAcademyContent from "../../components/contentpreview/UpcomingAcademyContent";

const AcademyPage: React.FC = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="main">
      <PageHeadingWithImage
        className="ze-academy"
        title={t("zeacademy-pageheading.title")}
        subtitle={t("zeacademy-pageheading.subtitle")}
        body={t("zeacademy-pageheading.body")}
      >
        {/*<Button*/}
        {/*  bootstrapClass="mx-2"*/}
        {/*  name={t("button.zeacademy-learn-more")}*/}
        {/*/>*/}
        {/*<Button name={t("button.sign-up")} buttonWhite={true} />*/}
      </PageHeadingWithImage>
      <GetStartedBanner />

      <div className="container mt-4">
        <h2>{t("zeacademy-learning-pathways.title")}</h2>
        <YellowDivider heading="h2" />
        <LearningPathwayContainer />
        <FeaturedAcademyContent
          title={t("zeacademy-featured-courses.title")}
          linkTitle={t("zeacademy-featured-courses.link-title")}
          link={`/${i18n.language}/academy/catalogue`}
        />
        {/*<FeaturedAcademyContent*/}
        {/*	title={t("zeacademy-featured-resources.title")}*/}
        {/*	linkTitle={t("zeacademy-featured-resources.link-title")}*/}
        {/*	link="/academy/catalogue"*/}
        {/*/>*/}
        <UpcomingAcademyContent
          title={t("zeacademy-upcoming-courses.title")}
          linkTitle={t("zeacademy-upcoming-courses.link-title")}
          link={`/${i18n.language}/academy/catalogue`}
        />
        {/* <FeaturedAcademyContent
          title={t("zeacademy-upcoming-courses.title")}
          linkTitle={t("zeacademy-upcoming-courses.link-title")}
          link={`/${i18n.language}/academy/catalogue`}
        /> */}
      </div>
      <StartLearningNowBanner />
    </div>
  );
};

export default AcademyPage;
